export default __webpack_public_path__ + "static/media/icon _search.0083b99d.svg";